import OrderTasksReportDataResource from '@/modules/to/order/resources/OrderTasksReportDataResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { WidgetDataResource } from '@/modules/ta/legacy/widget/resources/WidgetDataResource';

export class OrderTasksDataWidgetDataResource extends WidgetDataResource {
  constructor() {
    super(RouteGroup.ORDERTASKSREPORTS);
  }

  /**
   * @override
   * @param {Widget} widget
   * @param {Object} params
   * @returns {Promise<GenericDataModel[]>}
   */
  async getWidgetData(widget, params) {
    const { data_source_id, data_view_id } = widget;
    return OrderTasksReportDataResource.getData(data_source_id, data_view_id, params);
  }

  /**
   * @override
   * @param {Widget} widget
   * @param {Object} params
   * @returns {Promise<GenericDataModel[]>}
   * */
  async getColumns(widget, params) {
    const { data_source_id, data_view_id } = widget;
    return OrderTasksReportDataResource.getColumns(data_source_id, data_view_id, params);
  }

  /**
   * @param data_source_id
   * @param data_view_id
   * @param field
   * @returns {Promise<*>}
   */
  getValuesDistinct(data_source_id, data_view_id, field) {
    return OrderTasksReportDataResource.getValuesDistinct(data_source_id, data_view_id, field);
  }
}

export default new OrderTasksDataWidgetDataResource();
